<template>
  <!-- eslint-disable -->
  <div v-if="$roles($store.state.user.uid_roles, 'transaction') && customer && source" class="page px-4 px-md-4 pt-4">
    <div class="d-flex px-0 px-md-4 pb-4 align-center justify-space-between">
      <span class="font-weight-bold">
        Transaction List Customer {{ customer.phone }} in {{source}}
      </span>
      <span class="caption-small">
        Home > Transaction Customer
      </span>
    </div>
    <v-col cols="12" class="px-md-4">
      <span v-if="tableLoading">
        <span class="caption-small">
          Loading. Please wait...
        </span>
      </span>
       <v-card v-if="!tableLoading">
        <v-data-table          
          :headers="headers"
          :items="transactions"
          item-key="name"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          class="accent"    
          :loading="tableLoading"        
        >     
          <template v-slot:item.actions="{ item }">
            <v-tooltip right>
              <template #activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on" class="text-capitalize" color="primary">
                  <v-icon class="caption mr-1">
                    mdi-eye-outline
                  </v-icon>
                  View
                </v-btn>
              </template>
              <ol>
                <li v-for="(product, iProduct) in item.products" :key="'trx-product-' + product.name">{{ product.name }} {{ product.quantity }}</li>                
              </ol>
            </v-tooltip>
          </template>              
          <template v-slot:item.created="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.created }}
            </div>
          </template>
          <template v-slot:item.refid="{ item }">
            <div class="caption-small pb-1 d-flex align-center">
              {{ item.refid }}
            </div>
          </template>
          <template v-slot:item.payment_total="{ item }">
            <div class="caption-small pb-1 d-flex align-center" style="line-height: 120%;">
              {{ item.payment_total - item.shipping_total | price }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    
  </div>
</template>

<script>
export default {
  data: (vm) => ({
    search: '',
    customer: null,
    source: null,
    transactions: [],
    tableLoading: true
  }),
  computed: {
    headers () {
      return [
        {
          text: '',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Date',
          value: 'created',
          align: 'center',
          sortable: true
        },
        {
          text: 'Sales Code',
          value: 'refid',
          sortable: true,
          align: 'left'
        },
        {
          text: 'Transaction Total',
          value: 'payment_total',
          sortable: true,
          align: 'left'
        }
      ]
    }
  },
  mounted () {
    const { username, source } = this.$route.query

    if (username && source) {
      this.tableLoading = true
      this.$store.dispatch('USER_BY_ID', `?q=${username}`).then((res) => {
        if (res.status && res.data.data.record) {
          this.customer = res.data.data.record
          this.$store.dispatch('TRX_GET_BY_BUYER_BY_STOCKIST_USER', {
            buyerid: res.data.data.record.id,
            stockistuserid: source
          }).then((res) => {
            if (res.status) {
              this.transactions = res.data.data
            }
            this.tableLoading = false
          })
        }
      })
      const stockist = this.$store.state.stokist.find((stockist) => Number(stockist.id) === Number(source))
      this.source = stockist.user_name
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.select-default {
  width: 100px;
  .v-input__slot {
    height: 30px!important;
    min-height: 30px!important;
    .v-input__append-inner {
      margin-top: 4px!important;
    }
  }
}
</style>
